// extracted by mini-css-extract-plugin
export default {"root":"Icons_root__KFGFr","smallIcon":"Icons_smallIcon__dovzS"};